import { RecursoFiltro } from "app/entity/recurso-filtro.model";
import { Component, Input, Output, EventEmitter } from "@angular/core";
import { BaseStepComponent } from "../../../base";
import { SelectItem } from "primeng/primeng";
import { ValidarData, dataFimLimite } from "app/util/custom.validators";
import { FuncaoExercidaHipoteses } from "app/entity/funcao-exercida-hipoteses.model";

@Component({
  // tslint:disable-next-line: component-selector
  selector: "gerenciamento-pos-graduacao-etapa1",
  templateUrl: "./etapa1.component.html",
})
export class GerenciamentoPosGraduacaoEtapa1Component extends BaseStepComponent {
  tipoDeAtividade = [
    { id: 1, tipo: "Graduação" },
    { id: 2, tipo: "Pós-graduação" },
  ];

  tipoAtividade: number;
  descricaoVisivel: boolean;
  descricaoSelecionada: string;
  funcaoExercidaLista: FuncaoExercidaHipoteses[] = [];

  mostrarDescricao(descricao: string) {
    this.descricaoSelecionada = descricao;
    this.descricaoVisivel = true;
  }

  validarTipoDeAtividade() {
    this.tipoAtividade = this.cadastro.get(
      "pos_graduacao.tipo_atividade"
    ).value;
  }

  @Input() mostrarCodigo: boolean;
  // tslint:disable-next-line: no-input-rename
  @Input("Anexos") listaAnexos: any[];
  @Input() listaDadosInstituicao: SelectItem[];
  @Input() listaTipoAtividade: SelectItem[];
  @Input() listaResumo: any[];
  @Input() listaRelatores: any[];
  @Input() validateForm: any = false;
  @Input() listaTipoPosGraduacao: SelectItem[];
  @Input() listaConteudo: SelectItem[];
  @Input() listaArea: SelectItem[];

  @Output() listaAnexoChange = new EventEmitter<any>();
  @Output() listaConteudoChange = new EventEmitter<any>();
  @Output() carregarObj = new EventEmitter<any>();
  @Output() stepObject: EventEmitter<any> = new EventEmitter<any>(true);
  @Output() validateFormChange = new EventEmitter<any>();
  @Input() listaCapacitadora: any[] = [];
  @Input() cpf: string;
  @Input() justificativa: string;
  @Input() recursoFiltro: RecursoFiltro;
  userInteracted = false;

  init() {
    this.listaAnexoChange.emit(this.listaAnexos);
    this.stepObject.emit(this);
    this.emitValidation(true);
  }
  emitValidation(isInit = false) {
    this.cadastro.value.funcao_exercida_hipoteses = this.funcaoExercidaLista;
    if (this.cadastro.value.funcao_exercida_hipoteses == null) {
      this.cadastro.value.funcao_exercida_hipoteses = this.funcaoExercidaLista;
    }

    if (isInit) {
      this.validateForm = [];
    } else {
      const countListaArquivos = this.listaAnexos.length;
      const countListaConteudo = this.listaConteudo.length;
      const inicio = new Date(
        this.cadastro.get("pos_graduacao.data_inicio").value
      );
      const fim = new Date(this.cadastro.get("pos_graduacao.data_fim").value);
      if (!ValidarData(inicio, fim)) {
        super.showMsg(
          "warn",
          "Pós-Graduação",
          "A data fim não pode ser menor que a data de início."
        );
        return;
      } else if (
        this.cadastro.get("pos_graduacao").valid &&
        countListaArquivos > 0 &&
        countListaConteudo > 0 &&
        dataFimLimite(fim)
      ) {
        this.isValid = true;
        this.carregarObj.emit(this.cadastro);
      } else if (!dataFimLimite(fim)) {
        const exercicio: number = new Date().getFullYear();
        this.cadastro.get("pos_graduacao.data_fim").setErrors({
          error: `A data fim não pode ser maior que o último dia do exercício vigente: 31/12/${exercicio}.`,
        });
        super.showMsg(
          "warn",
          "Data Fim",
          `A data fim não pode ser maior que o último dia do exercício vigente: 31/12/${exercicio}.`
        );
        return;
      } else {
        this.isValid = false;
        this.validateForm = [this.cadastro.get("pos_graduacao")];
        if (countListaArquivos === 0) {
          // tslint:disable-next-line: max-line-length
          this.showMsgWarn(
            `<p>O anexo de arquivos é obrigatório.<br><br> Todos os arquivos deverão ser anexados de uma só vez.</p>`
          );
        } else if (countListaConteudo == 0) {
          this.showMsgWarn(`<p>É necessario ao menos um conteúdo.</p>`);
        } else if (!this.cadastro.valid) {
          this.cadastro.markAsTouched();
          this.showMsg(
            "warn",
            "Campos inválidos",
            "Verifique o preenchimento do formulário."
          );
        }
      }
    }
    setTimeout(() => this.validateFormChange.emit(this.validateForm), 0);
    this.isValidChange.emit(this.isValid);
  }

  onCalendarInteraction() {
    this.userInteracted = true;
  }
  onDataFimChange(event: any) {
    if (this.userInteracted) {
      this.cadastro.get('pos_graduacao.id_natureza').setValue(null);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/gerenciamento-pos-graduacao/crud/etapa1/etapa1.component.ts